import { render, staticRenderFns } from "./PreviewCard.vue?vue&type=template&id=71bd4156&scoped=true&"
import script from "./PreviewCard.vue?vue&type=script&lang=js&"
export * from "./PreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./PreviewCard.vue?vue&type=style&index=0&id=71bd4156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bd4156",
  null
  
)

export default component.exports